// The Lead layout (desktop): setup, work instructions, oversight and records,
// in MIST.Web's shell: the drawer with the brand and the navigation on the left,
// the workspace bar across the top (which carries the way back to MIST). A layout, not a permission: the same role
// builds and leads (D2).
import { NavLink, Outlet } from 'react-router';

import { BrandMark, Icon } from '../design/components';
import type { MistIcon } from '../design/mist-icons';
import { AppBar } from './AppBar';

const LINKS: readonly { to: string; label: string; icon: MistIcon; end: boolean }[] = [
    { to: '/lead', label: 'Floor overview', icon: 'spaceDashboard', end: true },
    { to: '/lead/queue', label: 'Priority', icon: 'lowPriority', end: false },
    { to: '/lead/instructions', label: 'Instructions', icon: 'menuBook', end: false },
    { to: '/lead/problems', label: 'Problems', icon: 'reportProblem', end: false },
    { to: '/lead/records', label: 'Records', icon: 'factCheck', end: false },
    { to: '/lead/numbers', label: 'Numbers', icon: 'insights', end: false },
    { to: '/lead/stations', label: 'Stations', icon: 'tune', end: false },
];

export function LeadLayout() {
    return (
        <div className="sf-app sf-app--drawer">
            <aside className="sf-drawer">
                <div className="sf-drawer-body">
                    <div className="sf-drawer-header">
                        <BrandMark />
                    </div>
                    <nav className="sf-nav" aria-label="Lead">
                        {LINKS.map((link) => (
                            <NavLink key={link.to} to={link.to} end={link.end}>
                                <Icon name={link.icon} />
                                {link.label}
                            </NavLink>
                        ))}
                        <span className="eyebrow sf-nav-section">Elsewhere</span>
                        <NavLink to="/floor">
                            <Icon name="tabletMac" />
                            Floor view
                        </NavLink>
                    </nav>
                </div>
            </aside>
            <AppBar workspace="Shop floor · Lead" />
            <main className="sf-page" id="main">
                <Outlet />
            </main>
        </div>
    );
}
